import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-note-modal',
  templateUrl: './add-note-modal.component.html',
  styleUrls: ['./add-note-modal.component.scss']
})
export class AddNoteModalComponent {
  noteText = '';
  maxLength = 5000;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { notes: any[] },
    private dialogRef: MatDialogRef<AddNoteModalComponent>
  ) {}

  get charCount(): number {
    return this.noteText.length;
  }

  get remainingChars(): number {
    return this.maxLength - this.charCount;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onDone(): void {
    if (this.noteText.trim()) {
      this.dialogRef.close(this.noteText.trim());
    }
  }
}